var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 31,
    viewBox: "0 0 43 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.768 12.5311C35.1994 12.5311 34.6491 12.61 34.1218 12.7493C34.1447 12.5126 34.1584 12.2712 34.1584 12.0252C34.1584 7.85284 30.8155 4.46943 26.693 4.46943C25.4136 4.46943 24.2122 4.79431 23.1621 5.36982C21.6121 2.19063 18.3884 0 14.6511 0C9.40515 0 5.15426 4.30235 5.15426 9.61184C5.15426 10.6886 5.33769 11.7236 5.66327 12.6936C2.46708 13.1066 0 15.8542 0 19.1958C0 22.7881 2.85685 25.7074 6.39697 25.7538V25.7584L35.768 25.8605C39.4044 25.8605 42.353 22.8763 42.353 19.1958C42.353 15.5154 39.4044 12.5311 35.768 12.5311Z",
    fill: "#F5CC3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3037 9.62169C10.3037 7.49604 12.0096 5.76953 14.1098 5.76953",
    stroke: "#FCEFD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8346 8.25195C29.1094 8.25195 30.1458 9.30085 30.1458 10.5911",
    stroke: "#FCEFD8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCloud);
export default __webpack_public_path__ + "static/media/warning-cloud.7f58d80a849d7573e93831819aeb716a.svg";
export { ForwardRef as ReactComponent };